import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, obj=logged in
  const [token, setToken] = useState(localStorage.getItem("nlcs_customer_token"));

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      setCustomer(false);
      return;
    }
    if (!token) {
      setCustomer(false);
      return;
    }
    api
      .get("/customer/me")
      .then((res) => setCustomer(res.data))
      .catch(() => {
        localStorage.removeItem("nlcs_customer_token");
        setToken(null);
        setCustomer(false);
      });
  }, [token]);

  const applySession = (tok, user) => {
    localStorage.setItem("nlcs_customer_token", tok);
    setToken(tok);
    setCustomer(user);
  };

  const loginEmail = async (email, password) => {
    const res = await api.post("/customer/login", { email, password });
    applySession(res.data.token, res.data.user);
    return res.data.user;
  };

  const register = async (name, email, password) => {
    const res = await api.post("/customer/register", { name, email, password });
    applySession(res.data.token, res.data.user);
    return res.data.user;
  };

  const exchangeSession = async (sessionId) => {
    const res = await api.post("/customer/session", { session_id: sessionId });
    applySession(res.data.token, res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/customer/logout");
    } catch (_) {}
    localStorage.removeItem("nlcs_customer_token");
    setToken(null);
    setCustomer(false);
  };

  return (
    <CustomerAuthContext.Provider
      value={{ customer, setCustomer, loginEmail, register, exchangeSession, logout }}
    >
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
